import api from './Axios';

/**
 * Loans API
 * Base: /api/loans
 */

// Health check endpoint
export const testLoansApi = () =>
  api.get('/loans/test');

// Guarantor-related endpoints
export const getEligibleGuarantors = (loanAmount) =>
  api.get(`/loans/eligible-guarantors/${loanAmount}`);

export const getGuarantorRequests = () =>
  api.get('/loans/guarantor-requests');

export const getGuaranteeSummary = () =>
  api.get('/loans/guarantee-summary');

// User loan endpoints
export const getUserLoans = () =>
  api.get('/loans/user');

export const getLoansByUserId = (userId) =>
  api.get(`/loans/user/${userId}`);

// Admin endpoints
export const adminCreateLoan = (data) =>
  api.post('/loans/admin-create', data);

export const getAllLoans = () =>
  api.get('/loans');

// Loan creation and management
export const createLoan = (data) =>
  api.post('/loans', data);

export const createLoanWithGuarantors = (data) =>
  api.post('/loans/create-with-guarantors', data);

export const getLoanLiveStatus = (loanId) =>
  api.get(`/loans/${loanId}/live-status`);

export const getLoanById = (loanId) =>
  api.get(`/loans/${loanId}`);

// Guarantor management
export const addGuarantorRequest = (loanId, data) =>
  api.post(`/loans/${loanId}/guarantor`, data);

export const respondToGuarantorRequest = (loanId, data) =>
  api.put(`/loans/${loanId}/guarantor-response`, data);

// Loan workflow
export const submitLoanForApproval = (loanId) =>
  api.put(`/loans/${loanId}/submit`);

export const processLoan = (loanId, data) =>
  api.put(`/loans/${loanId}/process`, data);

// Repayment
export const addRepayment = (loanId, data) =>
  api.post(`/loans/${loanId}/repayment`, data);

// Admin edit loan
export const editLoan = (loanId, data) =>
  api.put(`/loans/${loanId}/edit`, data);